import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import * as React from 'react';
import { Strings } from '../../../../utils/resources/strings';
import { DoItYourselfComponentProps, DoItYourselfComponentHandler, DoItYourselfComponentState } from './doityourselfcomponent';
import { DoItYourselfCSSStyle } from './doityouselfcss';
import { TextComponent } from '../../../toolkit/text/textcomponent';
import { CheckboxComponent } from '../../../toolkit/checkbox/checkboxcomponent';
import { FileUploadStatus } from '../../../toolkit/fileupload/fileuploadcomponent';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
import { UploadKaroakeDto, UploadKaroakeDtoImpl } from '../../../../core/dto/uploadkaroake/uploadkaroakedto';
import { DragDropFileUploadComponent } from '../../../toolkit/dragdropfile/dragdropfileuploadcomponent';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../popup/confirmrequest/confirmrequestconfirmbuttoncss';
import { DoItYourselfCheckboxCSSStyleImpl } from './doityourselfcheckboxcss';
// import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';


export class DoItYourselfViewImpl extends CRBTUIViewImpl
{
    private rememberCheckBox: CheckboxComponent | null;
    private textComponent: TextComponent;
    private fileUploadComponent: DragDropFileUploadComponent;
    private popupComponent: PopUpWrapperComponent;

    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(applicationContext, uiComponentHandler);
    }

    bindHandlers()
    {
        this.onTermsConditionSelected = this.onTermsConditionSelected.bind(this);
        this.onSubmitClicked = this.onSubmitClicked.bind(this);
        this.onFileSelected = this.onFileSelected.bind(this);
        this.onReupload = this.onReupload.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
        this.invalidFile = this.invalidFile.bind(this);
    }

    getChildComponent(props: DoItYourselfComponentProps, state: DoItYourselfComponentState, cssStyle: DoItYourselfCSSStyle): JSX.Element
    {  
        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
            <label style={cssStyle.getDoItYourselfTextCSSStyle()}>
                    {props.context.getResources().getString(Strings.doityourself)}
            </label>
            <label style={cssStyle.getTitleTextCSSStyle()}>
            {
                props.context.getResources().getString(Strings.doityourself_msg)}
            </label>
            <div style={cssStyle.getTuneNameCSSStyle()}>
                    <TextComponent hint={props.context.getResources().getString(Strings.name_your_tune)} maxLength={this.getUIProps().context.getResources().getString(Strings.tune_name_max_length)} label={props.context.getResources().getString(Strings.name_your_tune)} placeholder={props.context.getResources().getString(Strings.name_your_tune)}  isDisabled={false} ref={(item: any) => this.textComponent = item} id={"#tunename"} value={state.toneName} inputType={"text"} isRequired={true}  context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.tunenameerrormsg)}/> 
                {/* <div style={{display: "inline-block", width: "320px"}}>
                </div> */}
            </div>
           
            <div style={cssStyle.getUploadCSSStyle()}>
                <DragDropFileUploadComponent uploadProgressStatus={state.uploadProgressPercentage} invalidFile={this.invalidFile} onReupload={this.onReupload} onFileSelected={this.onFileSelected} ref={(item: any)=>{this.fileUploadComponent=item;}} fileUploadStatus={state.fileUploadStatus} context={props.context}/>
            </div>
            <div style={cssStyle.getRowDivCSSStyle()}>
                    <CheckboxComponent  isEditable={true} ref={(item: any) => this.rememberCheckBox = item} style={new DoItYourselfCheckboxCSSStyleImpl(props.context)} onChange={() => {}} context={props.context} isChecked={props.context.getUserContext().getTermsAndConditionsRemember()}/>
                    <label style={cssStyle.getReadCSSStyle()}>{props.context.getResources().getString(Strings.i_have_read_and_agree_to_th)}</label>
                    <a target="_blank" href={props.context.getConfigurationSettings().getPropertyBasedOnLanguage("DIY_TND")}><label onClick={this.onTermsConditionSelected} style={cssStyle.getTermsConditionsCSSStyle()}>{props.context.getResources().getString(Strings.terms_conditions)}</label></a>
            </div>
            <div style={cssStyle.getSubmitCSSStyle(state.fileUploadStatus === FileUploadStatus.FILE_PREVIEW?false:true)}>
                <ButtonComponent onClick={state.fileUploadStatus === FileUploadStatus.FILE_PREVIEW ? this.onSubmitClicked : () => {}} style={state.fileUploadStatus === FileUploadStatus.FILE_PREVIEW ? new ConfirmRequestConfirmButtonCSSStyleImpl(props.context): new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.submit)}/>
            </div>
            <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={props.context}/>
            </div>
        );
    }

    validate(): boolean
    {   
        if(this.textComponent.validate())
        {
            let tuneNameMinLength = +this.getUIProps().context.getResources().getString(Strings.tuneNameMinLength);
            let tuneNamemaxLength = +this.getUIProps().context.getResources().getString(Strings.tuneNameMaxLength);

            if(this.textComponent.getData().length < tuneNameMinLength 
                            || this.textComponent.getData().length > tuneNamemaxLength)
            {
                this.textComponent.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.tuneNameInvalidLength));
                return false;
            }
            
            return true;
        }
        else
        {
            return false;
        }
    }

    validateFile(): boolean
    {
        if(this.fileUploadComponent !== null && this.fileUploadComponent.validate())
        {
            let file: any = this.fileUploadComponent.getData();

            let fileMinLength = +this.getUIProps().context.getResources().getString(Strings.fileMinLength);
            let filemaxLength = +this.getUIProps().context.getResources().getString(Strings.fileMaxLength);
            
            if((file.size/1000) < fileMinLength || (file.size/1000) > filemaxLength)
                {
                    return false;
                }
                else
                {
                    return true;
                }
        }
        else
        {
            return false;
        }
    }

    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.home),
             this.getUIProps().context.getResources().getString(Strings.doityourself)];
    }

    getBannerImg()
    {
        return "doityouself.jpg";
    }

    isRememberMe(): boolean
    {
        return this.rememberCheckBox !== null && this.rememberCheckBox.isChecked();
    }

    getData(): UploadKaroakeDto
    {
        let uploadkaroake = new UploadKaroakeDtoImpl();
        
        uploadkaroake.setToneName(this.textComponent.getData());
        uploadkaroake.setToneFile(this.fileUploadComponent.getData());

        return uploadkaroake;
    }

    clearData()
    {
        this.textComponent.clearData();
        this.fileUploadComponent.clearData();
    }

    showPopup(msg: string, type: AlertType,title:string)
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.hidePopup} onClick={this.hidePopup} context={this.getUIProps().context}/>);
    }

    hidePopup()
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    }

    private invalidFile(msg: string)
    {
        this.showPopup(msg, AlertType.WARN, this.getContext().getResources().getString(Strings.tryagain));
    }

    private onTermsConditionSelected()
    {

    }

    private onSubmitClicked()
    {
        (this.getUIComponentHandler() as DoItYourselfComponentHandler).onSubmitClicked();
    }

    private onFileSelected()
    {
        (this.getUIComponentHandler() as DoItYourselfComponentHandler).onFileSelected(this.textComponent.getData());
    }

    private onReupload()
    {
        console.log("onreupload of do it yourself.");
        
        (this.getUIComponentHandler() as DoItYourselfComponentHandler).onReuploadClicked();
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/doityourself/doityourselfview.tsx